export default "__VITE_ASSET__BdAS4ehc__"